import React from 'react'
import { connect } from "react-redux"

import { Link } from 'react-router-dom' // When clicking a <Link>, the URL will be updated and the rendered content will change without reloading the page.

import { Form } from 'react-form'

import { Button } from 'primereact/button'
import { Toolbar } from 'primereact/toolbar'
import { Card } from 'primereact/card'

import FieldInputText from '../components/common/FieldInputText'
import FieldPassword from '../components/common/FieldPassword'

import * as appActionCreators from "../actionCreators/app"
import * as authActionCreators from "../actionCreators/auth"

import '../css/login.css'

class Login extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // flag stored at container level because we want to know when the container itself has loaded so we can hide/show based on that
      // this way any loading done by child components doesn't cause the container to be hidden
      hasLoaded: false,
      userLoginDetails: {}
    }
  }

  componentDidMount() {
    document.title = "Login - BoardingCall - South Australian Government Boards and Committees";
    // clear session timeout flag in case redirected here after timeout
    // that way we don't keep getting redirected
    this.props.clearSessionTimeOut()

    //is invoked immediately after a component is mounted. 
    //Initialization that requires DOM nodes should go here. If you need to load data from a remote endpoint, this is a good place to instantiate the network request.   
    this.props.setLoading(true)
      .then(() => this.props.getLoginDetails())
      .then((response) => this.setState({ userLoginDetails: response.data }))
      .then(() => this.props.setLoading(false))
      .then(() => this.setState({ hasLoaded: true }))
      .catch((error) => {
        this.props.handleError(error)
          .then(() => this.props.setLoading(false))
      })
  }

  formFailedSubmission = (errors, onSubmitError, formApi) => {
    console.log(JSON.stringify(errors));
    if (Object.keys(errors).length > 0)
    {
      let firstErrorObjectId = Object.keys(errors)[0];
      console.log(firstErrorObjectId);
      if (firstErrorObjectId)
      {
        var element = document.querySelector('#' + firstErrorObjectId);
        if (element)
        {
          if (element.tagName.toLowerCase() === "div")
          {
            element = document.querySelector('#' + firstErrorObjectId + ' input');
          }
          if (element)
          {
            element.focus();
          }
        }
      }
    }
  }

  performLogin = userLoginDetails => {
    this.props.setLoading(true)
      .then(() => this.props.performLogin(userLoginDetails))
      .then(response => {
        if (response && response.data && response.data.access_token && this.props.auth.candidateId) {
          this.props.history.push('/candidate/' + this.props.auth.candidateId)
        } else if (response && response.data && response.data.access_token) {
          this.props.history.push('/')
        } else {
          let response = {
            data: {
              Success: false,
              ErrorMessages: {
                $values: ['Invalid login details.']
              }
            }
          }
          this.props.setAjaxResponse(response)
        }

        this.props.setLoading(false)
      })
      .catch((error) => {
        this.props.handleError(error)
          .then(() => this.props.setLoading(false))
      })
  }

  render() {
    let validationRules = this.state.userLoginDetails.ValidationRules ? this.state.userLoginDetails.ValidationRules.$values : []
    const loginHeader = <h2 className="p-card-title">Login</h2>
    return (
      <Form values={this.state.userLoginDetails} onSubmit={this.performLogin} onSubmitFailure={this.formFailedSubmission}>
        {formApi => {
          return (
            <React.Fragment>
              {this.state.hasLoaded && <Card header={loginHeader} className="login-card">
                <div className="p-grid">
                  <div className="p-col-12 ui-md-12 ui-lg-12" >
                    <FieldInputText field={"Username"} label={"Email"} autoFocus="true" validationRules={validationRules}  aria-label="Email"/>
                  </div>
                  <div className="p-col-12 ui-md-12 ui-lg-12">
                    <FieldPassword field={"Password"} label={"Password"} feedback={false} validationRules={validationRules}  aria-label="Password"  />
                  </div>
                  <div className="p-col-12 ui-md-12 ui-lg-12">
                    <Link to='/forgot-password'>
                      <div>Forgot My Password</div>
                    </Link>
                  </div>
                </div>
                <Toolbar>
                  <div className="p-toolbar-group-left">
                    {/* submits react-form's Form which performs validation and triggers submit event if successful */}
                    <Button label="Login" icon="pi pi-check" onClick={formApi.submitForm} />
                  </div>
                </Toolbar>
              </Card>}
            </React.Fragment>
          )
        }}
      </Form>
    )
  }
}

const mapStateToProps = (state) => {
  const { auth } = state
  return { auth }
}

// this is how to combine actions available
const actionCreators = {
  ...authActionCreators,
  ...appActionCreators
}

export default connect(mapStateToProps, actionCreators)(Login)


// WEBPACK FOOTER //
// ./src/container/Login.js